import { type FC } from 'react';

import TitledAvatar from 'components/TitledAvatar';
import CollectionTagItem from 'components/CollectionTag';

import { RouteTypes } from 'RouteTypes';
import { type CollectorProps } from './types';

import {
  CollectorWrapper, CollectorNumber, CollectorTagWrapper, UserNameWrapper, UserTitleWrapper,
} from './styled';

const Collector: FC<CollectorProps> = ({ collector, index }) => (
  <CollectorWrapper data-test-id="collector_wrapper" to={RouteTypes.User.replace(':username', collector.username)}>
    <TitledAvatar data-test-id="collector" avatar={collector.avatar} username={collector.username}>
      <UserTitleWrapper size="title" textColor="textWhite" bold>
        {collector.name}
      </UserTitleWrapper>
      <UserNameWrapper size="title" textColor="textWhite">
        {collector.username && `@${collector.username}`}
      </UserNameWrapper>
      <CollectorTagWrapper data-test-id="collector_tag_wrapper">
        {collector.tags?.map((item) => (
          <CollectionTagItem item={item} key={item} />
        ))}
      </CollectorTagWrapper>
    </TitledAvatar>
    <CollectorNumber
      data-test-id="collector_number"
      data-index-attribute={`${index}`}
      textColor="primary"
      font="secondary"
      size="unmedia48"
      uppercase
    >
      #
      {' '}
      {index}
    </CollectorNumber>
  </CollectorWrapper>
);

export default Collector;
